export class PromiseCanceledError extends Error {
  constructor () {
    super('Promise has been canceled')
  }
}

export class CancelablePromise<T> {
  private hasCanceled_ = false
  promise: Promise<T>

  constructor (innerPromise: Promise<T>) {
    this.promise = new Promise((resolve: Function, reject: Function) => {
      innerPromise.then((val: any) =>
        this.hasCanceled_ ? reject(new PromiseCanceledError()) : resolve(val)
      )
      innerPromise.catch((error: any) =>
        this.hasCanceled_ ? reject(new PromiseCanceledError()) : reject(error)
      )
    })
  }

  cancel () {
    this.hasCanceled_ = true
  }
}
